import * as React from 'react';
import { Button } from 'baseui/button';
import { Pagination } from 'baseui/pagination';
import { expandBorderStyles } from 'baseui/styles';

export default function DynamicPagination(props) {
  const { hasNext, currentPage, onPrevClick, onNextClick, onPageChange } = props;
  const numPages = hasNext ? currentPage + 1 : currentPage;

  return (
    <Pagination
      numPages={numPages}
      currentPage={currentPage}
      onPageChange={({ nextPage }) => {
        if (nextPage > currentPage && onNextClick) {
          onNextClick();
        } else if (nextPage < currentPage && onPrevClick) {
          onPrevClick();
        }
      }}
      overrides={{
        MaxLabel: {
          style: ({ $theme }) => ({
            display: 'none', // Hide the label showing the max number of pages
          }),
        },
        DropdownContainer: {
          style: ({ $theme }) => ({
            display: 'none', // Hide the current page number
            
          }),
        },
      }}
    />
  );
}
